const stats = [
  { value: '150+', label: 'Countries Served' },
  { value: '99.8%', label: 'On-Time Delivery Rate' },
  { value: '$0', label: 'Loss Claims (2024)' },
  { value: '24/7', label: 'Operations Center' },
];

export default function Stats() {
  return (
    <section id="about" className="relative bg-secondary-50 py-20 md:py-28 px-6 md:px-10 lg:px-16">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-12 md:mb-20">
          <span className="inline-block px-4 py-2 rounded-full bg-white text-foreground-800 text-xs font-semibold tracking-wide mb-6">
            LICENSED · BONDED · INSURED
          </span>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight max-w-3xl">
            Three decades of securing<br />
            what cannot be replaced
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-14 md:mb-20">
          <div>
            <p className="text-foreground-600 text-sm leading-relaxed">
              Every shipment is assigned a dedicated logistics coordinator who remains your single point of contact from pickup to verified delivery.
            </p>
          </div>
          <div>
            <p className="text-foreground-600 text-sm leading-relaxed">
              Our carrier network includes only vetted, licensed, and bonded partners with proven track records in high-value goods transport.
            </p>
          </div>
          <div>
            <p className="text-foreground-600 text-sm leading-relaxed">
              Real-time GPS tracking with geofence alerts and tamper detection provides complete transparency throughout the entire journey.
            </p>
          </div>
          <div>
            <p className="text-foreground-600 text-sm leading-relaxed">
              Declared-value insurance coverage up to the full replacement cost — not a capped liability limit found with standard carriers.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10">
          {stats.map((stat, i) => (
            <div key={i} className="text-center lg:text-left">
              <div className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-primary-700 mb-2">
                {stat.value}
              </div>
              <p className="text-foreground-500 text-xs md:text-sm font-medium tracking-wide uppercase">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}